/*
Author: Chathuraka Mallawa Arachchi
Date: 05/02/2025
Copyright © 2024 Infix!. All rights reserved.

Responsible for form creating basic nodes
*/
import { INode } from '@/components/survey/SurveyModel/types/nodeTypes'
import { IComponentMetaData } from './types/commonTypes'

const nodeGenerator = (function () {
    const generateNode = (name: string, type: string) => {
        const node: INode = {
            validations: [],
            name: name,
            type: type,
        }
        return node
    }

    const transformMetaData = (metaData: IComponentMetaData) => {
        return {
            label: {
                display: metaData?.label?.display ?? true,
            },
            title: {
                display: metaData?.title?.display ?? true,
            },
            subTitle: {
                display: metaData?.subTitle?.display ?? true,
            },
        }
    }
    return {
        generateNode,
        transformMetaData,
    }
})()

export default nodeGenerator
